import React, {useState, useEffect} from 'react';
import style from './style.module.scss';
import {IProps, IHandlers, IServiceItem} from './types';
import {Radio, FormControlLabel, withStyles, Theme, useTheme} from '@material-ui/core';
import MuiTypography from '@material-ui/core/Typography';
import MuiRadioGroup from '@material-ui/core/RadioGroup';
import {renderIf} from "app/services/reactUtils.service";

const NS = 'ServicePicker';

const RadioGroup = withStyles({
  root: {
    display: 'block'
  }
})(MuiRadioGroup);

export default function ServicePicker({
  selectedId, serviceList, showAutoMessage, handleServiceSelected
}: IProps & IHandlers) {

  function getSelectedOpt(_selectedId: string) {
    return serviceList.find(({service}) => service._id === _selectedId);
  }

  const {palette}: Theme = useTheme();

  const AutoMsg = withStyles({
    root: {
      color: palette.warning.main,
      marginBottom: 5,
      fontSize: '1.5rem'
    }
  })(MuiTypography);

  const [selectedOpt, setSelectedOpt] = useState<IServiceItem>(getSelectedOpt(selectedId));
  useEffect(() => { setSelectedOpt(getSelectedOpt(selectedId)); }, [selectedId]);

  return (
    <div className={style.root}>
      <RadioGroup aria-label="services"
        name="services"
        value={selectedOpt ? selectedOpt.serviceIndex : ''}
        onChange={(evt, serviceIndex) => {
          const item: IServiceItem = serviceList.find(service => service.serviceIndex === parseInt(serviceIndex));
          setSelectedOpt(item);
          handleServiceSelected(item && item.service._id || null);
        }}>

        {serviceList.map(({name, serviceIndex}) => (
          <FormControlLabel
            key={serviceIndex}
            value={serviceIndex}
            control={
              <Radio color="primary" />
            } label={name} />
        ))}
      </RadioGroup>
      {renderIf(showAutoMessage, () => (
        <AutoMsg>
          Service has been auto-selected (previous service was invalid).
        </AutoMsg>
      ))}
    </div>
  )
}

